import type { ReactNode } from 'react';
import InfoTooltip from '../InfoTooltip';
import Required from './Required';

interface StaticFieldProps {
  id?: string;
  label: string;
  value?: ReactNode;
  link?: string;
  tooltipText?: string;
}

export default function Static({ id = Math.random().toString(), label, value, tooltipText }: StaticFieldProps) {
  if (!value) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-1 font-noto">
      <div className="flex items-center gap-1 leading-snug">
        <label htmlFor={id} className="text-xs capitalize text-grey-60">
          <span>{label}</span>
          <Required isRequired={false} />
        </label>
        {tooltipText && <InfoTooltip text={tooltipText} label={`About ${label}`} />}
      </div>
      <div className="flex w-full rounded-sm">
        <div className="text-xs font-medium text-primary">{value}</div>
      </div>
    </div>
  );
}
